import React from 'react'
import './Button.css'

const Button = props => {
  const className = props.className 
    ? `button ${props.className}` 
    : 'button'
  
  return (
    <a 
      href={props.href} 
      download={props.download} 
      target={props.target || '_self'}
      className={className}
    >
      <div>{props.text}</div>
    </a>
  )
}

export default Button